import { render, staticRenderFns } from "./PaymentsAndCurrenciesSystem.vue?vue&type=template&id=070c6fd9&"
import script from "./PaymentsAndCurrenciesSystem.vue?vue&type=script&lang=js&"
export * from "./PaymentsAndCurrenciesSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports